const TELEMETRY_MAX_LOOKBACK_MS = 24 * 60 * 60 * 1000
const TELEMETRY_DEFAULT_LOOKBACK_MS = 3 * 60 * 60 * 1000

export function getTelemetryDefaultFromValue(): string {
  return toDatetimeLocalValue(new Date(Date.now() - TELEMETRY_DEFAULT_LOOKBACK_MS))
}

export function getTelemetryMinFromValue(): string {
  return toDatetimeLocalValue(new Date(Date.now() - TELEMETRY_MAX_LOOKBACK_MS), 'ceil')
}

export function getTelemetryMaxFromValue(): string {
  return toDatetimeLocalValue(new Date())
}

export function clampTelemetryFromValue(value: string): string {
  const date = new Date(value)

  if (Number.isNaN(date.getTime())) {
    return getTelemetryDefaultFromValue()
  }

  const now = Date.now()
  const minTime = now - TELEMETRY_MAX_LOOKBACK_MS

  if (date.getTime() > now) {
    return toDatetimeLocalValue(new Date(now))
  }

  if (floorToMinute(date).getTime() < minTime) {
    return toDatetimeLocalValue(new Date(minTime), 'ceil')
  }

  return toDatetimeLocalValue(date)
}

export function toTelemetryFromQuery(value: string): string | undefined {
  const clampedValue = clampTelemetryFromValue(value)
  const date = new Date(clampedValue)

  if (Number.isNaN(date.getTime())) {
    return undefined
  }

  return date.toISOString()
}

function toDatetimeLocalValue(date: Date, round: 'floor' | 'ceil' = 'floor'): string {
  const roundedDate = round === 'ceil' ? ceilToMinute(date) : floorToMinute(date)
  const tzOffsetMs = roundedDate.getTimezoneOffset() * 60_000
  return new Date(roundedDate.getTime() - tzOffsetMs).toISOString().slice(0, 16)
}

function floorToMinute(date: Date): Date {
  const roundedDate = new Date(date)
  roundedDate.setSeconds(0, 0)
  return roundedDate
}

function ceilToMinute(date: Date): Date {
  const roundedDate = new Date(date)

  if (roundedDate.getSeconds() > 0 || roundedDate.getMilliseconds() > 0) {
    roundedDate.setMinutes(roundedDate.getMinutes() + 1)
  }

  roundedDate.setSeconds(0, 0)
  return roundedDate
}
